import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { findObjFromList } from '../../../../../Js/generalFunctions';
import { PurchaseReportNewSingleAPI } from './purchaseReportNewAPI';
import { getCurrentTime } from '../../../../../Js/Date';
import Template from "./purchaseReportSinglePrint"
import { IconButton, Tooltip } from '@mui/material';
import ReactToPrint from 'react-to-print';
import PrintComponentList from "../../../SalesNew/SalesReport/TableListPrint";
import ExcelJS from "exceljs";

export const PurchaseReportSingleView = () => {
    let navigate = useNavigate();
    let paymentsPrint = useRef();
     const printRef = useRef(); 

    const [symbol, setSymbol] = useState(null);
    const name = localStorage.getItem("name")
    const id = localStorage.getItem("singleViewId")
    const fromDate = localStorage.getItem("fromDate")
    const toDate = localStorage.getItem("toDate")
    const branch = localStorage.getItem("branch")

    const singleView = useSelector((state) => state?.purchaseRport?.purhaseReportNwSingleList)

    const decimalPosition = localStorage.getItem("decimalPosition");

    const currencyListUpdated = useSelector(
        (state) => state?.viewUpdatedCurrency?.value
    );
    const companyProfileData = useSelector(
        (state) => state?.companyProfileSlice?.userValue
    );
    const handleback = () => {
        navigate("/userdashboard/purchasemanager/PurchaseReport/PurchaseReportNew")
    }

      const downloadList = () => {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Purchase Report");
        sheet.properties.defaultRowHeight = 20;
    
        // Add header section
        const titleRow = sheet.addRow(["Purchase Report"]);
        titleRow.font = { size: 18, bold: true };
        sheet.mergeCells("A1:F1");
        titleRow.getCell(1).alignment = {
          vertical: "middle",
          horizontal: "center",
        };
    
        sheet.addRow([]);
    
        // Header row styling
        const headerRow = sheet.addRow([
          "Date",
          "Vendor",
          "Bill No.",
          "Qty",
          "Unit Price",
          "Total",
        ]);
        const headerFill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF1d1da7" }, // Use full hex code with "FF" prefix for better compatibility
        };
        const headerFont = {
          size: 15,
          bold: true,
          color: { argb: "FFFFFFFF" }, // White font color
        };
    
        headerRow.eachCell((cell) => {
          cell.fill = headerFill;
          cell.font = headerFont;
          cell.alignment = { vertical: "middle", horizontal: "center" }; // Ensure header text is centered
        });
    
        sheet.columns = [
          { header: "Date", key: "date", width: 20 },
          { header: "Vendor", key: "vendorName", width: 20 },
          { header: "Bill No.", key: "invoiceNo", width: 20 },
          { header: "Qty", key: "qty", width: 20 },
          { header: "Unit Price", key: "unitPrice", width: 20 },
          { header: "Purchase Report", key: "totalAmount", width: 20 },
        ];
    
        singleView?.table?.forEach((item) => {
          const row = sheet.addRow({
            date: item?.date,
            vendorName: ` ${item?.vendorName}`,
            invoiceNo: ` ${item?.invoiceNo}`,
            qty: ` ${item?.qty}`,
            unitPrice: ` ${item?.unitPrice?.toFixed(2)}`,
            totalAmount: ` ${item?.totalAmount?.toFixed(2)}`,
          });
    
          const rowFill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFFFFFF" }, // Use full hex code with "FF" prefix for better compatibility
          };
    
          row.eachCell((cell, colNumber) => {
            cell.fill = rowFill;
            cell.border = {
              top: { style: "thin", color: { argb: "FFC2CBF9" } },
              left: { style: "thin", color: { argb: "FFC2CBF9" } },
              bottom: { style: "thin", color: { argb: "FFC2CBF9" } },
              right: { style: "thin", color: { argb: "FFC2CBF9" } },
            };
            if (colNumber > 1) {
              // Right align all columns except the first
              cell.alignment = { horizontal: "right" };
            }
          });
        });
    
        // Add row for totals
        const totalRow = sheet.addRow([
          "Total",
          "",
          "",
          "",
          "",
          `${symbol} ${singleView?.amountTotal?.toFixed(2)}`,
        ]);
    
        // Merge cells from A to E
        sheet.mergeCells(`A${totalRow.number}:D${totalRow.number}`);
    
        totalRow.eachCell((cell, colNumber) => {
          cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
          cell.fill = headerFill;
          cell.border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
          if (colNumber > 1) {
            // Right align all columns except the first
            cell.alignment = { horizontal: "right" };
          }
        });
    
        workbook.xlsx.writeBuffer().then(function (data) {
          const blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement("a");
          anchor.href = url;
          anchor.download = "Purchase Report Single View.xlsx";
          anchor.click();
          window.URL.revokeObjectURL(url);
        });
      };

    useEffect(() => {
        let currencyObj = findObjFromList(
            "_id",
            currencyListUpdated,
            "currency",
            companyProfileData
        );
        setSymbol(currencyObj?.symbol);
    }, [companyProfileData, currencyListUpdated]);

    useEffect(() => {
        PurchaseReportNewSingleAPI({
            branchId: branch,
            fromDate: fromDate === '' ? '' : `${fromDate} ${getCurrentTime()}`,
            endDate: toDate === '' ? '' : `${toDate} ${getCurrentTime()}`,
            productId: id
        })
    }, [])

    return (
        <div className="global-page-parent-container" style={{ margin: "0" }}>
            <div className="global-white-bg-container">
                <div style={{justifyContent: "space-between", display: "flex", alignItems: "center" }}>
                    <div style={{display:"flex"}}>
                        <div className="sharp-arrow" style={{height:"auto"}} onClick={() => handleback()}> <p>Purchase Report &gt;</p></div>
                        <div className="sharp-arrow" style={{ width: "auto" }}> <p>{name}</p></div>
                    </div>
                    {/* <div>
                        <Tooltip title="Share">
                            <IconButton>
                                <i
                                    class="bi bi-share"
                                    style={{
                                        backgroundColor: "#9797e9",
                                        color: "white",
                                        fontSize: "medium",
                                        padding: "8px",
                                        borderRadius: "2px",
                                    }}
                                ></i>
                            </IconButton>
                        </Tooltip>

                        <ReactToPrint
                            trigger={() => (
                                <IconButton className="printer-div" style={{ padding: "1px" }}>
                                    <i
                                        style={{
                                            color: "white",
                                            backgroundColor: " #d787e7",
                                            fontSize: "medium",
                                            padding: "8px",
                                            borderRadius: "2px",
                                        }}
                                        class="bi bi-printer"
                                    ></i>
                                </IconButton>
                            )}
                            content={() => paymentsPrint}
                        />

                        <Tooltip title="Download">
                            <IconButton>
                                <i
                                    class="bi bi-arrow-down-circle"
                                    style={{
                                        backgroundColor: "rgb(255 118 133 / 69%)",
                                        color: "white",
                                        fontSize: "medium",
                                        padding: "8px",
                                        borderRadius: "2px",
                                    }}
                                ></i>
                            </IconButton>
                        </Tooltip>
                    </div> */}
                      <div className="justify-center" style={{ gap: "10px", width: "70%", justifyContent: "flex-end" }}>
             <PrintComponentList contentRef={printRef} />
             <Tooltip title="Download">
    <span>
        <IconButton
            style={{
                backgroundColor: "#ffd2d2",
                color: "#002995",
                borderRadius: "0",
                height: "38px",
                width: "37px",
            }}
            onClick={downloadList}
        >
            <i className="bi bi-arrow-down-circle"></i>
        </IconButton>
    </span>
</Tooltip>

           </div>
                </div>
                <div className='global-report-table-container' style={{ maxHeight: "80vh" }} ref={printRef}>
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Vendor</th>
                                <th>Bill No.</th>
                                <th>Qty</th>
                                <th>Unit Price</th>
                                <th>Total</th>
                            </tr>

                        </thead>
                        <tbody>

                            {singleView?.table?.map((item, index) => (
                                <tr key={index} style={{ height: "38px" }}>
                                    <td style={{ backgroundColor: "white", border: "0.8px solid #c3d4f7" }}>{item.date}</td>
                                    <td style={{ backgroundColor: "white", border: "0.8px solid #c3d4f7" }}>{item.vendorName}</td>
                                    <td style={{ backgroundColor: "white", border: "0.8px solid #c3d4f7" }}>{item.invoiceNo}</td>
                                    <td style={{ backgroundColor: "white", border: "0.8px solid #c3d4f7" }}>{item.qty}</td>
                                    <td style={{ backgroundColor: "white", border: "0.8px solid #c3d4f7" }}>{symbol}&nbsp;{item.unitPrice}</td>
                                    <td style={{ backgroundColor: "white", border: "0.8px solid #c3d4f7" }}>{symbol}&nbsp;{item.totalAmount}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colSpan="5">Total</th>
                                <th>{symbol}&nbsp;{singleView?.amountTotal}</th>

                            </tr>
                        </tfoot>
                    </table>

                </div>
            </div>
            {/* <div style={{ display: "none" }}>
                <div ref={(el) => (paymentsPrint = el)}>

                    <Template singleView={singleView} symbol={symbol} />

                </div>
            </div> */}
        </div>

    )
}



